import './ProfileHeader.css';

const ProfileHeader = ({ logo, title, bio }) => {
  return (
    <div className="profile-section">
      {logo && (
        <div className="profile-logo-wrapper">
          <img src={logo} alt={title || 'Perfil'} className="profile-logo" />
        </div>
      )}
      {title && <h1 className="profile-title">{title}</h1>}
      {bio && <p className="profile-bio">{bio}</p>}
    </div>
  );
};

export default ProfileHeader;

